// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._9l0xAj6XmAoZtUIjwUI{position:relative;overflow:hidden}.gcmEeej9BIpDTOjQcl8M{width:100%;height:100%;display:flex;position:relative;overflow:hidden}.SFXOm6Z_iAI98hYlFal9{flex-direction:column;width:100%;min-width:620px;max-width:620px;padding-top:30px;display:flex;overflow:hidden}.whsjJAV38c4QfTDgeBBT{flex-direction:column;margin-bottom:8px;padding:0 80px;display:flex}.Y2pFsTVC50jt_MoSRWfA{background-color:var(--gray-a-15);border-radius:4px;align-self:flex-start;margin-bottom:24px;padding:3.5px 8px;display:inline-block}.aezixRqhiMQxtFgdowRO{flex:1;min-height:0}.zlFoJdfKX4qXlCNoHQPk{justify-content:flex-end;padding:24px 80px 64px;display:flex}.DH0HBeQZkfoIKFZvsrti{width:100%}.VNZgvzCTPXYvncflMeQN{border-left:1px solid var(--border-neutral-default);flex:1;display:flex}.RYwrU_cUh9oZcFH7EBGg{position:absolute;top:24px;right:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `_9l0xAj6XmAoZtUIjwUI`,
	"wrap": `gcmEeej9BIpDTOjQcl8M`,
	"main": `SFXOm6Z_iAI98hYlFal9`,
	"header": `whsjJAV38c4QfTDgeBBT`,
	"badge": `Y2pFsTVC50jt_MoSRWfA`,
	"formArea": `aezixRqhiMQxtFgdowRO`,
	"actions": `zlFoJdfKX4qXlCNoHQPk`,
	"nextButton": `DH0HBeQZkfoIKFZvsrti`,
	"preview": `VNZgvzCTPXYvncflMeQN`,
	"close": `RYwrU_cUh9oZcFH7EBGg`
};
export default ___CSS_LOADER_EXPORT___;
